// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"53e91f0a","513":"d8733498","703":"9f78325b","787":"f7c7665f"}[chunkId] + ".chunk.js";
};